<script>
    import { currency_formatter } from "../globals";
    import Header from "../components/Header.svelte";
    import Button from '@smui/button/styled';
    import Textfield from '@smui/textfield/styled';
    import HelperText from '@smui/textfield/helper-text/index';
    import CharacterCounter from '@smui/textfield/character-counter/index';
    import Select, { Option } from '@smui/select/styled';
    import GoogleMap from '../components/GoogleMap.svelte';
    import CreditCard from "svelte-credit-cards";
    import Datepicker from 'svelte-calendar';
    import Loading from '../pages/Loading.svelte';
    import { formatDate } from 'timeUtils';
    import { formatDate as formatDateFromUtils } from '../utils/format.js';
    import * as yup from 'yup';
    import Payment from "payment";
    import { navigate } from "svelte-routing";
    import { api_host, user_store, domain_code_store, price_settings_store, places_store, plan_type_store, site_activate_store, page_setting_store } from "../stores.js";
    import { doAPIPost, doFetch } from '../utils/Fetching.svelte';
    import { toast } from '@zerodevx/svelte-toast';
    import { toast_message } from '../utils/toast_message.js';
    import { getTotalTax, getSubtotal } from "../../../bam/src/utils/tax";
    import Swal from "sweetalert2";
    import { init_data } from '../init.js';
    import { getTax } from "../utils/tax";


    let myself = {};
    let field_data = {};
    let domain_code = '';
    let plan_type = '';
    let is_site_activated = false;
    let address_data = { address: "", city: "", state: "" };
    let referral_code = '';
    let all_data_from_link = {};
    let is_booking_link = false;
	let available_places = {};
    let place_checked_store = false;
    let ref_discount = 0;
    const today = new Date();
    let dateFormat = '#{D}, #{M} #{j}, #{Y}';
    let selectedDateFormatted = "";
    let selectedDate;
    let nextServiceDate;
    let nextServiceDateFormattedSimple = "00-00-0000";
    $: selectedDateFormattedSimple = (selectedDate === undefined) ? "00-00-0000" : formatDate(selectedDate,'#{m}-#{d}-#{Y}');

    site_activate_store.subscribe(value => {
        is_site_activated = value;
    });

    const formSchema = yup.object().shape({
        first_name: yup
            .string()
            // .matches(/^([a-zA-Z]+\s)*[a-zA-Z]+$/, { message: 'Only alphabets are allowed' })
            .required('First Name is Required'),
            // .min(3, 'Too short! minimum 3 characters'),
        last_name: yup
            .string()
            .required('Last Name is Required'),
        email: yup.string().required('This Field is Required').email('Invalid email'),
        home_phone: yup
            .string()
            .required('Home Phone is Required')
            .matches(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, {
                message: 'Invalid phone number',
            }),
        mobile_phone: yup
            .string()
            .test('mobile-is-good', 'Invalid phone number.', value => {return (value === null || value.match(/^ *$/) !== null) || (value.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/));}),
        cc_name: yup
            .string()
            .required('This must match the name on your card.')
            .matches(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g, {
                message: 'Invalid Name',
            }),
        cc_number: yup
            .string()
            .required('This must match the number on your card.')
            .test('cc-is-good', 'Card number is invalid.', value => Payment.fns.validateCardNumber(value)),
        cc_expiry: yup
            .string()
            .required('Expiration date is required')
            .max(5, 'Not a valid expiration date. Example: MM/YY')
            .matches(
                /([0-9]{2})\/([0-9]{2})/,
                'Not a valid expiration date. Example: MM/YY'
            )
            .test('expiry-is-good', 'Expiration date is invalid.', value => Payment.fns.validateCardExpiry(value)),
        cc_cvc: yup
            .string()
            .required('This is a 3 or 4 digit number.')
            .min(3, 'Must be at least 3 digits.')
            .max(4, 'Must be a 3 or 4 digit number.')
            .matches(
                /^[0-9]{3,4}$/,
                'Code must be a 3 or 4 digit number.'
            ),
    });
    for (let nk in formSchema.describe().fields) {
        field_data[nk] = "";
        field_data[`${nk}_iv`] = false;
        field_data[`${nk}_h`] = "";
    }

    user_store.subscribe(value => {
        myself = value;
        console.log(myself);
    });
    places_store.subscribe(async (value) => {
        await process_address(window.location.search);
        available_places = value;
        const avaialble_states = Object.keys(available_places);
        const available_state = avaialble_states.find(avaialble_state => (avaialble_state.toLowerCase() === address_data.state.toLowerCase() || available_places[avaialble_state].state_code === address_data.state));
        if (!available_state) {
            console.log('invalid state');
            window.location.href = '/invalid_address';
            return;
        }
        const avaialble_cities = available_places[available_state].cities;
        const available_city = avaialble_cities.find(available_city => available_city.city.toLowerCase() === address_data.city.toLowerCase());
        if (!available_city) {
            console.log('invalid city');
            window.location.href = '/invalid_address';
            return;
        }
        const available_zipcodes = available_city.zipcodes ?? [];
        if (available_zipcodes.length > 0 && address_data.zipcode && !available_zipcodes.includes(address_data.zipcode)) {
            console.log('invalid zipcode');
            window.location.href = '/invalid_address';
            return;
        }
        place_checked_store = true;           
    });
    plan_type_store.subscribe(value => {
        plan_type = value;
    });
    domain_code_store.subscribe(value => {
        domain_code = value;
    });
    
    let pricing_factors = {
        client_margin: 1.7,
        contractor_margin: 0.8,
        yard_factor_for_story_1: 0.38,
        yard_factor_for_story_gt_1: 0.45,
        lawn_factor_front_or_back: 1.0,
        lawn_factor_front_and_back: 1.083,
        lawn_factor_none: 0.95,
        service_one_time: 1.65,
        service_weekly: 0.74,
        service_bi_weekly: 0.89,
        service_monthly: 1.157,
        last_time_less_2_weeks: 0.98,
        last_time_2_4_weeks: 1.56,
        last_time_1_2_months: 2.5,
        last_time_3_months_or_more: 3.8,
        referral_duration: 7,
        referral_discount: 10.0,
        discount_monthly_service: 0.3,
        min_charge: 0,
    }
    price_settings_store.subscribe(value => {
        if (Object.keys(value).length) {
            pricing_factors = {
                client_margin: value['client_margin'],
                contractor_margin: value['contractor_margin'],
                yard_factor_for_story_1: value['lawnfor_small_story'],
                yard_factor_for_story_gt_1: value['lawnfor_big_story'],
                lawn_factor_front_or_back: value['front_or_back'],
                lawn_factor_front_and_back: value['front_and_back'],
                lawn_factor_none: value['no_lawn'],
                service_one_time: value['one_time'],
                service_weekly: value['weekly'],
                service_bi_weekly: value['bi_weekly'],
                service_monthly: value['monthly'],
                last_time_less_2_weeks: value['last_serviced_2'],
                last_time_2_4_weeks: value['last_serviced_4'],
                last_time_1_2_months: value['last_serviced_8'],
                last_time_3_months_or_more: value['last_serviced_12'],
                referral_duration: value['referral_duration'],
                referral_discount: value['referral_discount'],
                discount_monthly_service: value['discount_monthly']
            };
        }
    });

    function getNextDate(the_date) {
        if (the_date !== undefined && service_frequency !== undefined) {
            const date = new Date(the_date.getTime());
            let bump_amount = 7;
            if (service_frequency === "Weekly") {
                bump_amount = 7;
            }
            if (service_frequency === "Bi-Weekly") {
                bump_amount = 14;
            }
            if (service_frequency === "Monthly") {
                bump_amount = 28;
            }
            if (service_frequency === 'Every 3 weeks') {
                bump_amount = 21;
            }
            if (service_frequency === 'Every 6 weeks') {
                bump_amount = 42;
            }
            if (service_frequency === 'Every 2 months') {
                bump_amount = 56;
            }

            if (service_frequency === "One-Time") {
                nextServiceDate = undefined;
            } else {
                date.setDate(date.getDate() + bump_amount);
                nextServiceDate = date;
            }
        } else {
            nextServiceDate = undefined;
        }
    }
    $: getNextDate(selectedDate, service_frequency);
    $: nextServiceDateFormattedSimple = (nextServiceDate === undefined) ? "00-00-0000" : formatDate(nextServiceDate,'#{m}-#{d}-#{Y}');

    let config_lawn_settings = [];
    let config_service_settings = [];
    let config_weekdays_settings = [];
    let config_time_preference_settings = [];

    let lawn = "";
    let lawn_options = [];

    let service_frequency = "";
    let service_options = [];

    let time_preference = "No Preference";
    let time_preference_options= [];


    page_setting_store.subscribe(page_setting => {
        if(page_setting.lawn_options == undefined) return;

        const day_number = {
            "Monday": 1,
            "Tuesday": 2,
            "Wednesday": 3,
            "Thursday": 4,
            "Friday": 5,
            "Saturday": 6,
            "Sunday": 0
        };

        config_lawn_settings = Object.keys(page_setting.lawn_options).filter(key => page_setting.lawn_options[key]);
        config_service_settings = Object.keys(page_setting.service_frequency_options).filter(key => page_setting.service_frequency_options[key]);
        config_weekdays_settings = Object.keys(page_setting.weekdays_options).filter(key => page_setting.weekdays_options[key]).map(key => day_number[key]);
        config_time_preference_settings = Object.keys(page_setting.time_preference_options).filter(key => page_setting.time_preference_options[key]);

        console.log('config_weekdays_settings', config_weekdays_settings);

        service_frequency = config_service_settings.length > 0 ? config_service_settings[0] : '';
        service_options = config_service_settings;
        lawn = config_lawn_settings.length > 0 ? config_lawn_settings[0] : '';
        lawn_options = config_lawn_settings;
        time_preference_options = config_time_preference_settings;
    });

    let last_service = "Less than 2 weeks ago";
    const last_service_options = ['Less than 2 weeks ago', '2 to 4 weeks ago', '1 to 2 months ago', '3 months or more'];

    let back_yard_entry = "Other";
    const back_yard_entry_options = ['Already Open', 'Ring Door Bell', 'Not Required', 'Other'];
    let coupon_code = "";
    let coupon_value = 0;
    let coupon_type = "";
    let additional_comments = "";
    let focused_field = "number";
    function setcvcfocus(){focused_field = "cvc";}
    function setnumberfocus(){focused_field = "number";}

    $: service_price = update_service_price(true, lawn, service_frequency, last_service, back_yard_entry) || all_data_from_link.total_service_price;
    $: next_service_price = update_service_price(false, lawn, service_frequency, last_service, back_yard_entry) || all_data_from_link.next_service_price;

    function update_service_price(is_first = true) {
        function calculate_yard_factor(_stories, _lot_size, _service){
            return _stories === 1 ? pricing_factors.yard_factor_for_story_1 : pricing_factors.yard_factor_for_story_gt_1
        }

        function calculate_lawn_factor(_lawn, _bad_shape){
            let res = pricing_factors.lawn_factor_front_or_back;

            if(_lawn === "Front AND Back"){ res = pricing_factors.lawn_factor_front_and_back;}
            if(_lawn === "None"){ res = pricing_factors.lawn_factor_none;}

            return res;
        }

        function calculate_service_factor(_service_type, _lot_size, _last_time, _bad_shape, _first){
            let res = {'Weekly': pricing_factors.service_weekly, 'Bi-Weekly':pricing_factors.service_bi_weekly, 'Monthly':pricing_factors.service_monthly, 'One-Time':pricing_factors.service_one_time}[_service_type];

            if (_first) {
                res *= {'Less than 2 weeks ago':pricing_factors.last_time_less_2_weeks, '2 to 4 weeks ago':pricing_factors.last_time_2_4_weeks, '1 to 2 months ago':pricing_factors.last_time_1_2_months, '3 months or more':pricing_factors.last_time_3_months_or_more}[_last_time];
            }

            if(_bad_shape){res *= pricing_factors.last_time_bad_shape}

            return res;
        }

        function price_by_yard_size(_lot_size, _first=true) {
            if(_first) {
                return 0.006 + 0.021 * 4000 / _lot_size;
            }else{
                return 0.006 + 0.017 * 3000 / _lot_size;
            }
        }

        function pricing_formula(_lot_size = 0, _lawn = false, _service_type = "One-Time", _last_time=14, _stories=1, _bad_shape=null, _weed_removal=false, _weed_control=false, _first_service=true) {
            _lot_size = parseFloat(_lot_size);
            _stories = parseFloat(_stories);
            
            let yard_factor = calculate_yard_factor(_stories, _lot_size, _service_type);
            let price_per_yard = price_by_yard_size(_lot_size, _first_service);
            let lawn_factor = calculate_lawn_factor(_lawn, _bad_shape);
            let service_factor = calculate_service_factor(_service_type, _lot_size, _last_time, _bad_shape, _first_service);

            let price = yard_factor * _lot_size * price_per_yard * lawn_factor * service_factor;

            let subtotal_price = (price * 1.2);
            subtotal_price = (subtotal_price * pricing_factors.client_margin);

            return subtotal_price.toFixed(2);
        }

        return pricing_formula(address_data.lot_size, lawn, service_frequency, last_service, address_data.building_stories, null, false, false, is_first);
    }

    $: full_name = `${field_data.first_name} ${field_data.last_name}`
    $: {
        if('cc_expiry' in field_data && field_data.cc_expiry !== undefined && field_data.cc_expiry.length > 2) {
            let tmp_expiry = field_data.cc_expiry.replace(/\D/g,'');
            if(tmp_expiry.length > 1) {
                tmp_expiry = tmp_expiry.slice(0, 2) + "/" + tmp_expiry.slice(2);
            }
            if(tmp_expiry.length > 5){
                tmp_expiry = tmp_expiry.substring(0, 5)
            }
            field_data.cc_expiry = tmp_expiry;
        }
    }

    function resetFieldData() {
        for (let nk in formSchema.describe().fields){
            field_data[`${nk}_iv`] = false;
            field_data[`${nk}_h`] = "";
        }
    }

    async function validateForm() {
        resetFieldData();
        let res = true;
        for (let nk in formSchema.describe().fields) {
            if (plan_type === 'basic' && (nk === 'cc_name' || nk === 'cc_number' || nk === 'cc_expiry' || nk === 'cc_cvc')) {
                field_data[nk] = '';
            } else {
                await formSchema.validateAt(nk, field_data, {
                    abortEarly: true  
                }).catch((err) => {
                    field_data[`${nk}_iv`] = true;
                    field_data[`${nk}_h`] = err.errors[0];
                    res = false;
                });
            }
        }
        return res;
    }

    async function validateSingle(nk) {
        const validateAtRes = await formSchema.validateAt(nk, field_data, {
            abortEarly: true  
        }).then(() => {
            field_data[`${nk}_iv`] = false;
            field_data[`${nk}_h`] = '';
        }).catch((err) => {
            field_data[`${nk}_iv`] = true;
            field_data[`${nk}_h`] = err.errors[0];
        });
    }

    async function process_address(address_query_string) {
        let res = false;
        const params = new URLSearchParams(address_query_string);

        if (params.has('ref')) {
            let ref_data = JSON.parse(atob(params.get('ref')));
            if (formatDateFromUtils(new Date()) <= formatDateFromUtils(ref_data['expiry_at']) && ref_data['is_recipient_used'] === false) {
                ref_discount = ref_data['discount'];
                referral_code = ref_data['referral_code'];
            }
        }
        if (params.has('address_data') === true) {
            let tdata = JSON.parse(atob(params.get('address_data')));
            console.log(tdata);
            if (tdata !== null && 'email' in tdata) {
                address_data = tdata;
                all_data_from_link = tdata;
                selectedDate = new Date(all_data_from_link.service_date || null);
                nextServiceDate = new Date(all_data_from_link.next_service_date || null);
                service_frequency = all_data_from_link.service_frequency;
                lawn = all_data_from_link.lawn;
                last_service = all_data_from_link.last_service;
                back_yard_entry = all_data_from_link.back_yard_entry;
                time_preference = all_data_from_link.time_preference;
                additional_comments = all_data_from_link.additional_comments;
                field_data.first_name = all_data_from_link.first_name;
                field_data.last_name = all_data_from_link.last_name;
                field_data.email = all_data_from_link.email;
                field_data.mobile_phone = all_data_from_link.mobile_phone;
                field_data.home_phone = all_data_from_link.home_phone;
                field_data.cc_name = all_data_from_link.cc_name;
                field_data.cc_number = all_data_from_link.cc_number;
                field_data.cc_cvc = all_data_from_link.cc_cvc;
                field_data.cc_expiry = all_data_from_link.cc_expiry;
            } else if (tdata !== null && 'address' in tdata) {
                address_data = tdata;
                if (myself.is_authenticated) {
                    field_data.first_name = myself.user.first_name;
                    field_data.last_name = myself.user.last_name;
                    field_data.email = myself.user.email;
                }
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                selectedDate = tomorrow;
                res = true;
            } else {
                navigate("/");
            }
        } else if (params.has('blid') === true) {
            is_booking_link = true;
            const bl_api_endpoint = `${api_host}/api/job/get/booking_link/${params.get('blid')}`;
            const res = await doFetch(
                bl_api_endpoint,
                'GET',
            );
            if (res.status) {
                let tdata = JSON.parse(res.content);
                if (tdata !== null && 'email' in tdata) {
                    console.log(tdata, 'tdata');
                    address_data = tdata;
                    all_data_from_link = tdata;
                    selectedDate = new Date(all_data_from_link.service_date || null);
                    nextServiceDate = new Date(all_data_from_link.next_service_date || null);
                    service_frequency = all_data_from_link.service_frequency;
                    lawn = all_data_from_link.lawn;
                    last_service = all_data_from_link.last_service;
                    back_yard_entry = all_data_from_link.back_yard_entry;
                    time_preference = all_data_from_link.time_preference;
                    additional_comments = all_data_from_link.additional_comments;
                    field_data.first_name = all_data_from_link.first_name;
                    field_data.last_name = all_data_from_link.last_name;
                    field_data.email = all_data_from_link.email;
                    field_data.mobile_phone = all_data_from_link.mobile_phone;
                    field_data.home_phone = all_data_from_link.home_phone;
                    field_data.cc_name = all_data_from_link.cc_name;
                    field_data.cc_number = all_data_from_link.cc_number;
                    field_data.cc_cvc = all_data_from_link.cc_cvc;
                    field_data.cc_expiry = all_data_from_link.cc_expiry;
                    field_data.crews = all_data_from_link.crews;
                    field_data.photos = all_data_from_link.photos ?? [];

                    if (!service_options.includes(service_frequency)) {
                        service_options.push(service_frequency);
                    }
                } else if (tdata !== null && 'address' in tdata) {
                    address_data = tdata;
                    if (myself.is_authenticated) {
                        field_data.first_name = myself.user.first_name;
                        field_data.last_name = myself.user.last_name;
                        field_data.email = myself.user.email;
                    }
                    res = true;
                } else {
                    toast_message(false, 'Something wrong, please try again', 3000);
                }
            } else {
                toast_message(false, res.msg || 'Bad request', 3000);
            }
        } else {
            if (address_data.address === "") {
                navigate("/");
            }
        }

        if (!(address_data.lot_size > 0) && !all_data_from_link.total_service_price) {
			Swal.fire({
				text: 'Online booking is not available. Please contact us for further information.',
				buttonsStyling: true,
				confirmButtonClass: 'button',
				confirmButtonText: 'OK',
				showCancelButton: false,
				icon: 'warning'
			}).then(async (e) => {
                window.location.href = ('/');
			});
        }

        return res;
    }

    const valid_min_charge = (_price) => {
        if (!is_booking_link && _price < pricing_factors.min_charge) return pricing_factors.min_charge;
        else return _price;
    }

    let disable_send = false;
    async function doBookJob() {
        if (await validateForm()) {
            disable_send = true;
            const turl = api_host + "/api/job/create_nj";
            
            service_price = parseFloat(service_price || 0)
            let service_prices = all_data_from_link.service_prices || [];
            let main_service_price = service_prices.find(_ => _.is_main);
            if (service_price > 0) {
                if (main_service_price) {
                    main_service_price.rate = service_price;
                    main_service_price.quantity = 1;
                } else {
                    main_service_price = {
                        rate: service_price,
                        quantity: 1,
                        tax_rates: [],
                        is_main: true
                    };
                    service_prices.push(main_service_price);
                }
            }
            if (main_service_price) {
                service_price = main_service_price.rate * main_service_price.quantity;
            } else {
                toast_message(false, 'Service price is required.', 3000);
                return;
            }

            let tax = 0;
            service_prices.forEach(p => tax += getTax(p.rate * p.quantity, p.tax_rates));
            let total_service_price = getSubtotal(service_prices) + tax;
            let contractor_price = pricing_factors.contractor_margin * service_price;
            let extra_contractor_prices = all_data_from_link.extra_contractor_prices || [];
            let extra_contractor_price = 0;
            extra_contractor_prices.forEach(_p => extra_contractor_price += _p.price);
            let total_contractor_price = parseFloat(contractor_price || 0) + parseFloat(extra_contractor_price || 0);

            const payload = {
                'is_manual': address_data.is_manual || false,
                "plan_type": plan_type || 'free',
                "address": address_data.address,
                "city": address_data.city,
                "state": address_data.state,
                "zipcode": address_data.zipcode,
                "service_date": selectedDateFormattedSimple,
                "next_service_date": nextServiceDateFormattedSimple,
                "time_preference": time_preference || 'No Preference',
                "lawn": lawn,
                "service_type": 'Yard/Lawn Service',
                "service_frequency": service_frequency,
                "last_service": last_service,
                "back_yard_entry": back_yard_entry,
                "first_name": field_data.first_name,
                "last_name": field_data.last_name,
                "full_name": full_name,
                "email": field_data.email,
                "mobile_phone": field_data.mobile_phone,
                "home_phone": field_data.home_phone,
                "extra_service_price": all_data_from_link.extra_service_price || 0,
                "service_price": service_price,
                "service_prices": service_prices,
                "total_service_price": total_service_price,
                "contractor_margin": pricing_factors.contractor_margin,
                "contractor_price": contractor_price || 0,
                "extra_contractor_prices": extra_contractor_prices,
                "extra_contractor_price": extra_contractor_price,
                "total_contractor_price": total_contractor_price,
                "next_service_price": valid_min_charge(parseFloat(next_service_price) > 0 ? next_service_price : parseFloat(all_data_from_link.next_service_price)),
                "additional_comments": additional_comments,
                "internal_comments": "",
                "paymethod": "Credit Card",
                "cc_name": field_data.cc_name,
                "cc_number": field_data.cc_number,
                "cc_cvc": field_data.cc_cvc,
                "cc_expiry": field_data.cc_expiry,
                "crews": field_data.crews || [],
                "referral_code": referral_code,
                "coupon_code": coupon_code,
                "photos": field_data.photos ?? []
            };
            if (all_data_from_link.qid) { payload["qid"] = all_data_from_link.qid; }
            const headers = {'Content-Type': 'application/json', 'DomainCode': domain_code};
            let res = await doAPIPost(
                turl,
                "Booking your lawn service appointment...",
                "Appoinment booked! Check your email for confirmation.",
                payload,
                headers,
                3000
            );
            disable_send = false;
            if (res) {
                navigate('/book_confirm');
            }
        } else {
            toast.push("Please fill out all required fields", {
                duration: 5000,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });
        }
    }

    $: first_service_price = valid_min_charge(parseFloat(service_price) > 0 ? service_price : all_data_from_link.total_service_price);
    $: coupon_discount = coupon_type.includes('Maximum Amount')  ? coupon_value : (first_service_price * coupon_value / 100);
</script>


{#if place_checked_store === true}
<Header />
<div class="formholder">
    <div class="serviceinformation infocard">
        <div class="title">Service Information</div>
        <div class="ff address" style={is_booking_link ? "pointer-events: none;" : ""}>
            <Textfield
                style="width: 100%;"
                helperLine$style="width: 100%;" 
                variant="filled" 
                bind:value={address_data.address}
                disabled 
                label="Address">
            </Textfield>            
        </div>

        <div class="ff city" style={is_booking_link ? "pointer-events: none;" : ""}>
            <Textfield 
                style="width: 100%;"
                helperLine$style="width: 100%;" 
                variant="filled" 
                bind:value={address_data.city}
                disabled
                label="City">
            </Textfield>            
        </div>
        
        <div class="ff state" style={is_booking_link ? "pointer-events: none;" : ""}>
            <Textfield 
                style="width: 100%;"
                helperLine$style="width: 100%;" 
                variant="filled" 
                bind:value={address_data.state}
                disabled
                label="State">
            </Textfield>            
        </div>
        
        <div class="ff dayofservice" style={is_booking_link ? "pointer-events: none;" : ""}>
            <Datepicker 
                buttonBackgroundColor='#00b300'
                buttonTextColor='white'
                start={today}
                format='{dateFormat}'
                selectableCallback={date => config_weekdays_settings.includes(date.getDay())}
                bind:formattedSelected={selectedDateFormatted}
                bind:selected={selectedDate}
            >
            </Datepicker>
        </div>

        <div class="ff timepreference" style={is_booking_link ? "pointer-events: none;" : ""}>
            <Select 
            variant="outlined"
            style="width: 100%;"
            bind:value={time_preference}
            label="Time Preference">
                <Option value="" />
                {#each time_preference_options as tp}
                  <Option value={tp}>{tp}</Option>
                {/each}
            </Select>
        </div>
        
        <div class="ff lawn" style={is_booking_link ? "pointer-events: none;" : ""}>
            <Select 
                variant="outlined" 
                style="width: 100%;"
                bind:value={lawn} 
                label="Lawn"
            >
                {#each lawn_options as lo}
                    <Option value={lo}>{lo}</Option>
                {/each}
            </Select>
        </div>
        
        <div class="ff service" style={is_booking_link ? "pointer-events: none;" : ""}>
            <Select 
                variant="outlined" 
                style="width: 100%;"
                bind:value={service_frequency} 
                label="Service Frequency"
            >
                {#each service_options as so}
                    <Option value={so}>{so}</Option>
                {/each}
            </Select>
        </div>
        
        <div class="ff lastservice" style={is_booking_link ? "pointer-events: none;" : ""}>
            <Select
                variant="outlined" 
                style="width: 100%;"
                bind:value={last_service} 
                label="Last Service by a Landscaper"
            >
                <Option value="" />
                {#each last_service_options as lso}
                    <Option value={lso}>{lso}</Option>
                {/each}
            </Select>
        </div>
        
        <div class="ff backyardentry" style={is_booking_link ? "pointer-events: none;" : ""}>
            <Select
                variant="outlined" 
                style="width: 100%;"
                bind:value={back_yard_entry} 
                label="Back Yard Entry Instructions"
            >
                <Option value="" />
                {#each back_yard_entry_options as byeo}
                    <Option value={byeo}>{byeo}</Option>
                {/each}
            </Select>
        </div>
        
        <div class="ff coupon">
            <Textfield
                style="width: 100%;"
                helperLine$style="width: 100%;"
                variant="outlined"
                label="Coupon Code"
                bind:value={coupon_code}
                on:blur={async () => {
                    if (coupon_code.length > 0) {
                        const res = await doFetch(
                            `${api_host}/api/coupon/check/${coupon_code}`,
                            'GET',
                            null,
                            { 'Content-Type': 'application/json', 'DomainCode': domain_code }
                        );
                        if (res.status) {
                            const { coupon } = res;
                            if (formatDateFromUtils(coupon.to_date) >= formatDateFromUtils(new Date())) {
                                coupon_value = coupon.value;
                                coupon_type = coupon.value_type;
                            } else {
                                coupon_value = 0;
                                toast_message(false, 'Invalid Code');
                            }
                        } else {
                            coupon_value = 0;
                            toast_message(false, res.msg || 'Invalid Code', 2000);
                        }
                    } else {
                        coupon_value = 0;
                    }
                }}
            >
                <HelperText slot="helper">If you have a coupon code, enter it here.</HelperText>
            </Textfield>            
        </div>
        
        <div class="ff additionalcomments">
            {#if is_booking_link === true}
                <Textfield
                    textarea
                    input$maxlength="1000"
                    input$readonly={true}
                    style="width: 100%; height: 100%"
                    bind:value={additional_comments}
                    label="Additional Comments"
                >
                    <CharacterCounter slot="internalCounter">0 / 1000</CharacterCounter>
                </Textfield>
            {:else}
                <Textfield
                    textarea
                    input$maxlength="1000"
                    style="width: 100%; height: 100%"
                    bind:value={additional_comments}
                    label="Additional Comments"
                >
                    <CharacterCounter slot="internalCounter">0 / 1000</CharacterCounter>
                </Textfield>
            {/if}
        </div>
    </div>

    <div class="contactinformation infocard">
        <div class="title">Contact Information</div>

        <div class="ff firstname">
            <Textfield 
                required
                invalid={field_data.first_name_iv}
                style="width: 100%;"
                helperLine$style="width: 100%;" 
                variant="outlined" 
                bind:value={field_data.first_name}
                on:input={() => {validateSingle('first_name')}}
                on:blur={() => {validateSingle('first_name')}}
                label="First Name">
                <HelperText validationMsg=true persistent=true slot="helper">{field_data.first_name_h}</HelperText>
            </Textfield>            
        </div>

        <div class="ff lastname">
            <Textfield 
                required
                invalid={field_data.last_name_iv}
                style="width: 100%;"
                helperLine$style="width: 100%;" 
                variant="outlined" 
                bind:value={field_data.last_name}
                on:input={() => {validateSingle('last_name')}}
                on:blur={() => {validateSingle('last_name')}}
                label="Last Name">
                <HelperText validationMsg=true persistent=true slot="helper">{field_data.last_name_h}</HelperText>
            </Textfield>            
        </div>
        
        <div class="ff email">
            <Textfield 
                required
                invalid={field_data.email_iv}
                style="width: 100%;"
                helperLine$style="width: 100%;" 
                variant="outlined" 
                bind:value={field_data.email}
                on:input={() => {validateSingle('email')}}
                on:blur={() => {validateSingle('email')}}
                label="Email"
                disabled={is_booking_link && false}
            >
                <HelperText validationMsg=true persistent=true slot="helper">{field_data.email_h}</HelperText>
            </Textfield>            
        </div>
        
        <div class="ff homephone">
            <Textfield 
                required
                invalid={field_data.home_phone_iv}
                style="width: 100%;"
                helperLine$style="width: 100%;" 
                variant="outlined" 
                bind:value={field_data.home_phone}
                on:input={() => {validateSingle('home_phone')}}
                on:blur={() => {validateSingle('home_phone')}}
                label="Home Phone">
                <HelperText validationMsg=true persistent=true slot="helper">{field_data.home_phone_h}</HelperText>
            </Textfield>            
        </div>
        
        <div class="ff mobilephone">
            <Textfield 
                style="width: 100%;"
                invalid={field_data.mobile_phone_iv}
                helperLine$style="width: 100%;" 
                variant="outlined" 
                bind:value={field_data.mobile_phone}
                on:input={() => {validateSingle('mobile_phone')}}
                on:blur={() => {validateSingle('mobile_phone')}}
                label="Mobile Phone">
                <HelperText validationMsg=true persistent=true slot="helper">{field_data.mobile_phone_h}</HelperText>
            </Textfield>            
        </div>
    </div>

    {#if plan_type !== 'basic'}
    <div class="paymentinformation infocard">
        <div class="title">Payment Information</div>

        <div class="ccformholder">
            <div class="ccpreviewholder">
                <CreditCard number="{field_data.cc_number}" name="{field_data.cc_name}" cvc="{field_data.cc_cvc}" expiry="{field_data.cc_expiry}" preview="{true}" focused="{focused_field}"/>
            </div>
            <div class="ccfieldsholder">
                <div class="ff cc-name">
                    <Textfield
                        required
                        invalid={field_data.cc_name_iv}
                        style="width: 100%;"
                        helperLine$style="width: 100%;" 
                        variant="outlined" 
                        bind:value={field_data.cc_name}
                        on:input={() => {validateSingle('cc_name')}}
                        on:blur={() => {validateSingle('cc_name')}}
                        label="Card Holder Name">
                        <HelperText validationMsg=true persistent=true slot="helper">{field_data.cc_name_h}</HelperText>
                    </Textfield>            
                </div>
                <div class="ff cc-number">
                    <Textfield 
                        id="cc_number"
                        required
                        input$pattern="\d+"
                        invalid={field_data.cc_number_iv}
                        style="width: 100%;"
                        helperLine$style="width: 100%;" 
                        variant="outlined" 
                        maxlength="16"
                        bind:value={field_data.cc_number}
                        on:input={() => {validateSingle('cc_number')}}
                        on:blur={() => {validateSingle('cc_number')}}
                        label="Card Number">
                        <HelperText validationMsg=true persistent=true slot="helper">{field_data.cc_number_h}</HelperText>
                    </Textfield>            
                </div>
                <div class="cc-expiry-date">
                    <div class="ff cc-expiry">
                        <Textfield 
                            required
                            invalid={field_data.cc_expiry_iv}
                            style="width: 100%;"
                            helperLine$style="width: 100%;" 
                            variant="outlined" 
                            bind:value={field_data.cc_expiry}
                            on:input={(evt) => {
                                if (evt.target.value.length === 2) {
                                    if (evt.inputType !== 'deleteContentBackward')
                                        field_data.cc_expiry = evt.target.value + '/';
                                }
                                else {
                                    if (evt.target.value.length === 3 && evt.target.value.charAt(2) !== '/')
                                        field_data.cc_expiry = evt.target.value.slice(0, 2) + '/' + evt.target.value.slice(2);
                                }
                                validateSingle('cc_expiry');
                            }}
                            on:blur={() => {validateSingle('cc_expiry')}}
                            label="Expiration Date">
                            <HelperText validationMsg=true persistent=true slot="helper">Example: MM/YY</HelperText>
                        </Textfield>            
                    </div>
                    <div class="ff cc-cvc">
                        <Textfield 
                            required
                            input$pattern="\d+"
                            invalid={field_data.cc_cvc_iv}
                            on:focus={setcvcfocus}
                            style="width: 100%;"
                            helperLine$style="width: 100%;" 
                            variant="outlined"
                            maxlength="4"
                            bind:value={field_data.cc_cvc}
                            on:input={() => {validateSingle('cc_cvc')}}
                            on:blur={() => {
                                validateSingle('cc_cvc');
                                setnumberfocus();
                            }}
                            label="CVC">
                            <HelperText validationMsg=true persistent=true slot="helper">{field_data.cc_cvc_h}</HelperText>
                        </Textfield>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/if}

    {#if is_site_activated}
    <div class="bookbutton">
        <Button 
            disabled={disable_send}
            on:click={() => {doBookJob();}}
            variant="raised" 
            class="button-shaped-round"
        >
            {plan_type !== 'basic' ? 'Book Now' : 'Contact Us'}
        </Button>
        <!-- <div class="aggreement-text">By booking this appointment you agree to our terms of service.</div> -->
    </div>
    {/if}

    <div class="serviceprice infocard">
        <div class="title">Service Price</div>
        {#if ref_discount > 0 || coupon_value > 0}
            <div class="serviceinforow">
                <div class="serviceinforowtitle">Original Service Price:</div>
                <div class="serviceinforowvalue highlightvalue">
                    <s style='text-decoration-thickness: 2px;'>
                        {currency_formatter.format(valid_min_charge(parseFloat(service_price) > 0 ? service_price : all_data_from_link.total_service_price))}
                    </s>
                </div>
            </div>
        {/if}
        {#if coupon_value > 0}
            <div class='serviceinforow' style='padding-left: 10px;'>
                ${coupon_discount.toFixed(2)} OFF Coupon Discount
            </div>
        {/if}
        <div class="serviceinfoservice">First Service</div>
        <div class="serviceinfoprice">
            {currency_formatter.format(first_service_price * ((100 - ref_discount) / 100) - coupon_discount)}
        </div>
        <div class="serviceinfohr"><hr /></div>
        <div class="serviceinforow">
            <div class="serviceinforowtitle">Service Frequency:</div>
            <div class="serviceinforowvalue">{service_frequency}</div>
        </div>
        <div class="serviceinforow">
            <div class="serviceinforowtitle">Service Date:</div>
            <div class="serviceinforowvalue">{selectedDateFormattedSimple}</div>
        </div>
        {#if service_frequency !== 'One-Time'}
        <div class="serviceinforow">
            <div class="serviceinforowtitle">Next Service Price:</div>
            <div class="serviceinforowvalue highlightvalue">{currency_formatter.format(valid_min_charge(parseFloat(next_service_price) > 0 ? next_service_price : all_data_from_link.next_service_price))}</div>
        </div>
        <div class="serviceinforow">
            <div class="serviceinforowtitle">Next Service Date:</div>
            <div class="serviceinforowvalue">{nextServiceDateFormattedSimple}</div>
        </div>
        {/if}
        <!-- <div div class="couponlink"><a href="/#/coupons?value={service_price}"><i class="fas fa-gift"></i> Send this service as a Gift Card</a></div> -->
    </div>

    <!-- <div class="location infocard">
        <div class="title">Location</div>
        <div class="locationmapholder">
            <GoogleMap address={address_data.address} city={address_data.city} state={address_data.state} />
        </div>
    </div> -->
</div>
{:else}
<Loading />
{/if}


<style>
    .formholder {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        display: grid;
        grid-template-columns: 2fr 1fr;
        grid-template-rows: 13fr;
        grid-template-areas: "si sp"
                             "si sp"
                             "si sp"
                             "si lo"
                             "si lo"
                             "si lo"
                             "si . "
                             "ci . "
                             "ci . "
                             "ci . "
                             "pi . "
                             "pi . "
                             "bb . ";
        gap: 25px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) { 
        .formholder {
            width: 100%;
            /* background-color: lime; */
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 6fr;
            grid-template-areas: "si"
                                 "ci"
                                 "sp"
                                 "pi"
                                 "bb"
                                 "lo";
        }
    }
    /* globals */
    .ff {
        padding: 10px;
    }
    .title {
        font-size: 23px;
        font-weight: bold;
    }
    .infocard {
        background-color: #E9E9EC;
        /* margin-bottom: 25px; */
    }
    .infocard > .title {
        background-color: white;
        padding-bottom: 20px;
    }
    /* service information  */
    .serviceinformation {
        grid-area: si;
        /* background-color: red; */
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        /* grid-template-rows: 30px repeat(7, 1fr); */
        grid-template-areas: "ti ti ti ti ti ti"
                             "ad ad ct ct st st"
                             "ds ds ds tp tp tp"
                             "la la la ss ss ss"
                             "ls ls ls ls ls ls"
                             "by by by gc gc gc"
                             "ac ac ac ac ac ac"
                             "ac ac ac ac ac ac";
    }
    @media (max-device-width: 1024px), (max-width: 1023px) { 
        .serviceinformation {
            width: 100%;
            /* background-color: lime; */
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 11fr;
            grid-template-areas: "ti"
                                 "ad"
                                 "ct"
                                 "st"
                                 "ds"
                                 "tp"
                                 "la"
                                 "ss"
                                 "ls"
                                 "by"
                                 "gc"
                                 "ac";
        }
    }
    .serviceinformation > .title {
        grid-area: ti;
    }
    .serviceinformation > .address {
        grid-area: ad;
    }
    .serviceinformation > .city {
        grid-area: ct;
    }
    .serviceinformation > .state {
        grid-area: st;
    }
    .serviceinformation > .dayofservice {
        grid-area: ds;
    }
    * :global(.datepicker) {
        width: 100% !important;
        height: 100%;
    }
    * :global(.calendar-button) {
        width: 90% !important;
        margin-left: auto;
        margin-right: auto;
        border: 1px solid black !important;
    }
    * :global(.calendar-button::after) {
        background-image: url('/img/calendar-alt-solid.png');
        background-size: 16px 16px;
        display: inline-block;
        width: 16px; 
        height: 16px;
        content:"";
        margin-left: 5px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) { 
        * :global(.calendar-button::after) {
            background-image: url('/img/calendar-alt-solid.png');
            background-size: 16px 16px;
            display: inline-block;
            width: 16px; 
            height: 16px;
            content:"";
            margin-left: 5px;
        }

    }
    * :global(.calendar-button::before) {
        display: inline-block;
        font-style: normal;
        font-weight: bold;
        font-variant: normal;
        text-rendering: auto;
        /* -webkit-font-smoothing: antialiased; */
        /* font-family: fontAwesome; */
        content: "Service Date:";
        margin-right: 25px;
    }
    .serviceinformation > .timepreference {
        grid-area: tp;
    }
    .serviceinformation > .lawn {
        grid-area: la;
    }
    .serviceinformation > .service {
        grid-area: ss;
    }
    .serviceinformation > .lastservice {
        grid-area: ls;
    }
    .serviceinformation > .backyardentry {
        grid-area: by;
    }
    .serviceinformation > .coupon {
        grid-area: gc;
    }
    .serviceinformation > .additionalcomments {
        grid-area: ac;
    }
    /* contact information */
    .contactinformation {
        grid-area: ci;
        /* background-color: orange; */
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: 30px repeat(3, 1fr);
        grid-template-areas:"ti ti"  
                            "fn ln"
                             "em hp"
                             "mp . ";
    }
    @media (max-device-width: 1024px), (max-width: 1023px) { 
        .contactinformation {
            width: 100%;
            /* background-color: lime; */
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 6fr;
            grid-template-areas: "ti"
                                 "fn"
                                 "ln"
                                 "em"
                                 "hp"
                                 "mp";
        }
    }
    .contactinformation > .title {
        grid-area: ti;
    }
    .contactinformation > .firstname {
        grid-area: fn;
    }
    .contactinformation > .lastname {
        grid-area: ln;
    }
    .contactinformation > .email {
        grid-area: em;
    }
    .contactinformation > .homephone {
        grid-area: hp;
    }
    .contactinformation > .mobilephone {
        grid-area: mp;
    }
    /* payment information */
    .paymentinformation {
        grid-area: pi;
        /* background-color: yellow; */
    }
    .paymentinformation > .ccformholder {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
    }
    .ccformholder > .ccpreviewholder {
        width: 50%;
    }
    .ccformholder > .ccfieldsholder {
        width: 50%;
        display: flex;
        flex-direction: column;
        /* justify-content: space-between; */
        
    }
    @media (max-device-width: 1024px), (max-width: 1023px) { 
        .ccformholder > .ccpreviewholder {
            width: 100%;
        }
        .ccformholder > .ccfieldsholder {
            width: 100%;
            display: flex;
            flex-direction: column;
            /* justify-content: space-between; */
            
        }
    }
    .cc-expiry-date {
        display: flex;
        flex-direction: row;
        width: 100%;
    }
    .cc-expiry-date > .cc-expiry {
        width: 50%;
    }
    .cc-expiry-date > .cc-cvc {
        width: 50%;
    }
    .bookbutton {
        grid-area: bb;
        /* background-color: gray; */
        padding: 20px;
    }
    /* service price */
    .serviceprice {
        grid-area: sp;
        /* background-color: blue; */
        display: flex;
        flex-direction: column;
        /* justify-content: space-around; */
    }
    .serviceprice > .serviceinfoservice {
        font-size: 20px;
        font-weight: bold;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 10px;
    }
    .serviceprice > .serviceinfoprice {
        font-size: 32px;
        font-weight: bold;
        padding: 10px;
    }
    .serviceprice > .serviceinfohr {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        padding-top: 5px;
        padding-bottom: 5px;
    }
    
    .serviceprice > .serviceinfohr > hr {
        color: rgba(0,0,0,0.2);
    }
    .serviceinforow {
        font-size: 17px;
        display: flex;
        width: 100%;
        /* padding: 10px; */
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .serviceinforow > .serviceinforowtitle { 
        font-weight: bold;
        text-align: left;
        width: 50%;
        padding-left: 10px;
        padding-right: 10px;
    }
    .serviceinforow > .serviceinforowvalue { 
        text-align: right;
        width: 50%;
        padding-left: 10px;
        padding-right: 10px;
        font-weight: lighter;
    }
    .highlightvalue {
        font-weight: bold !important;
    }
    /* location */
    .location {
        grid-area: lo;
        /* background-color: purple; */
        height: 300px;
    }
    .locationmapholder {
        width: 100%;
        height: 300px;
    }
</style>